var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as userAction from '../actions/user.action';
import { createReducer, on } from '@ngrx/store';
export var initialState = {
    data: null,
    loaded: false,
    loading: false
};
var ɵ0 = function (state) { return (__assign({}, state, { loading: true })); }, ɵ1 = function (state) { return (__assign({}, state, { loading: false, loaded: false })); }, ɵ2 = function (state, payload) {
    var data = payload;
    return __assign({}, state, { data: data, loading: false, loaded: false });
}, ɵ3 = function () {
    return __assign({}, initialState);
};
var userReducer = createReducer(initialState, on(userAction.getUser, ɵ0), on(userAction.getUserFail, ɵ1), on(userAction.getUserSuccess, ɵ2), on(userAction.logoutUserSuccess, ɵ3));
export function reducer(state, action) {
    return userReducer(state, action);
}
export var getUserLoading = function (state) { return state.loading; };
export var getUserLoaded = function (state) { return state.loaded; };
export var getUser = function (state) {
    return state.data;
};
export { ɵ0, ɵ1, ɵ2, ɵ3 };
